import { verifyToken, readMe } from "../actions/auth";
import { RoutesPaths } from "../Router/constant";

/**
 * Where to send someone who has just authenticated.
 *
 * Google sign-up creates a usable session immediately — there's no email to
 * verify — so those users go straight on: to the dashboard when the account
 * already has an assistant, otherwise into the onboarding steps. Manual
 * email/password sign-up is different: it has to clear the OTP first, so that
 * path deliberately doesn't come through here.
 *
 * @param {Function} dispatch
 * @returns {Promise<{hasAssistant: boolean, path: string, state?: object}>}
 */
export const resolveAuthLanding = async (dispatch) => {
  const resp = await dispatch(verifyToken());

  if (readMe(resp)?.hasAssistant) {
    return { hasAssistant: true, path: RoutesPaths.DASHBOARD };
  }

  return { hasAssistant: false, path: RoutesPaths.CREATE_ASSISTANT };
};
